import store from '../store'

// Quick and dirty to demo how the css classes are used.
export default class CheckoutProgress {
  constructor () {
    ({ dom: this.dom } = store)

    // Return if there is no open exampleModal btn
    if (!this.dom.checkoutProgress) { return }

    this.listItems = this.dom.checkoutProgress.querySelectorAll('.checkout-progress__list__item__link')

    console.log(this.listItems)

    this.addEvents()
  }

  addEvents () {
    this.listItems.forEach(element => {
      element.addEventListener('click', e => { this.clickStep(e) })
    })
  }

  clickStep (element) {
    this.listItems.forEach((el, index) => {
      if (el === element.currentTarget) {
        el.classList.add('is-active')
        this.dom.checkoutProgress.classList.add('checkout-progress--step-' + (index + 1))
      } else {
        el.classList.remove('is-active')
        this.dom.checkoutProgress.classList.remove('checkout-progress--step-' + (index + 1))
      }
    })
  }
}
